import React, { Component } from 'react';
import api from "./../../../../services/api";
import './style.css';
import { NavLink } from 'react-router-dom';
import { user_token } from './../../../../services/Auth';

//import da API
import { organizer } from './../../../../services/api';
let apiOrganizer = new organizer();


var token = localStorage.getItem(user_token);

//Classe para API
export default class ListaConfirmada extends Component {
  state = {
    nome: [],
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = async () => {
    // const request = await api.get('/agent/unauthorized', {headers: {'x-access-token': token}});
    const request = await apiOrganizer.getAllAgents([{ header: 'authenticated', value: false }]);
    console.log(request);
    console.log(request.data);
    this.setState({ nome: request.data });

  };

  render() {
    return (
      <>
        <div id="lista-style">

          {this.state.nome.map(name => (
            <>
              <NavLink to={{ pathname: '/Tela_Pedidos_Instituicoes/' + name._id }}>
                <button id="og-button" key={name._id}>{name.institucion_name}</button></NavLink>
            </>
          ))}
        </div>
      </>

    );
  }

}
